// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::before,
::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
}

.form__div-container {
  margin-bottom: 1.5rem;
}

.form__div {
  position: relative;
  height: 52px;
}

.form__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 0.9rem;
  border: 2px solid #dadce0;
  border-radius: 5px;
  outline: none;
  padding: 1rem;
  background: none;
  z-index: 1;
}

.form__label {
  position: absolute;
  left: 1rem;
  top: 1.08rem;
  padding: 0 0.25rem;
  background-color: #fff;
  color: #80868b;
  font-size: 1rem;
  transition: 0.3s;
}

/*Input focus move up label*/
.form__input:focus + .form__label {
  top: -0.4rem;
  left: 0.8rem;
  color: #1a73e8;
  font-size: 0.8rem;
  font-weight: 500;
  z-index: 10;
}

/*Input focus sticky top label*/
.form__input:not(:placeholder-shown).form__input:not(:focus) + .form__label {
  top: -0.4rem;
  left: 0.8rem;
  font-size: 0.8rem;
  font-weight: 500;
  z-index: 10;
}

/*Input focus*/
.form__input:focus {
  border: 2px solid #1a73e8;
}

.login-page {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.login-page .form-container {
  width: 100%;
  max-width: 450px;
  padding: 40px 20px;
  background: #fff;
  border-radius: 8px;
}
@media (min-width: 576px) {
  .login-page .form-container {
    border: 1px solid #dadce0;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    padding: 48px 38px;
  }
}
.login-page .form-container .signIn-txt {
  color: #212121;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.3333;
  margin: 0.5rem 0 1rem;
}
.login-page .form-container .subtext {
  color: gray;
}
.login-page .form-container .login-form {
  margin-top: 2rem;
}
.login-page .form-container .login-form .login-btn.blue-btn {
  background: #1a73e8;
  color: #fff;
  border: none;
  vertical-align: middle;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  padding: 9px 20px;
  border-radius: 4px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transition: 0.4s;
}
.login-page .form-container .login-form .login-btn.blue-btn:hover, .login-page .form-container .login-form .login-btn.blue-btn:focus {
  outline: none;
  background: #0b5bc0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/components/_input.scss","webpack://./src/assets/css/pages/login/style.scss"],"names":[],"mappings":"AAUA;;;EAGE,sBAAA;ACTF;;ADYA;EACE,SAAA;EACA,UAAA;EACA,iCAdU;EAeV,eAdiB;ACKnB;;ADYA;EACE,qBAAA;ACTF;;ADYA;EACE,kBAAA;EACA,YAAA;ACTF;;ADYA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;ACTF;;ADYA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,cApDY;EAqDZ,eAhDiB;EAiDjB,gBAAA;ACTF;;ADYA,4BAAA;AACA;EACE,YAAA;EACA,YAAA;EACA,cA9DY;EA+DZ,iBAxDgB;EAyDhB,gBAAA;EACA,WAAA;ACTF;;ADYA,+BAAA;AACA;EAEE,YAAA;EACA,YAAA;EACA,iBAlEgB;EAmEhB,gBAAA;EACA,WAAA;ACVF;;ADaA,cAAA;AACA;EACE,yBAAA;ACVF;;AApEA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;AAuEF;AArEE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAuEJ;AArEI;EAPF;IAQI,yBAAA;IACA,mFAAA;IAEA,kBAAA;EAuEJ;AACF;AArEI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAuEN;AApEI;EACE,WAAA;AAsEN;AAnEI;EACE,gBAAA;AAqEN;AAnEM;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uDAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yHAAA;EAEA,gBAAA;AAoER;AAlEQ;EAEE,aAAA;EACA,mBAAA;AAmEV","sourcesContent":["$first-color: #1a73e8;\r\n$input-color: #80868b;\r\n$border-color: #dadce0;\r\n\r\n\r\n$body-font: \"Roboto\", sans-serif;\r\n$normal-font-size: 1rem;\r\n$small-font-size: 0.8rem;\r\n\r\n\r\n*,\r\n::before,\r\n::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: $body-font;\r\n  font-size: $normal-font-size;\r\n}\r\n\r\n.form__div-container {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form__div {\r\n  position: relative;\r\n  height: 52px;\r\n}\r\n\r\n.form__input {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  font-size: .9rem;\r\n  border: 2px solid $border-color;\r\n  border-radius: 5px;\r\n  outline: none;\r\n  padding: 1rem;\r\n  background: none;\r\n  z-index: 1;\r\n}\r\n\r\n.form__label {\r\n  position: absolute;\r\n  left: 1rem;\r\n  top: 1.08rem;\r\n  padding: 0 0.25rem;\r\n  background-color: #fff;\r\n  color: $input-color;\r\n  font-size: $normal-font-size;\r\n  transition: 0.3s;\r\n}\r\n\r\n/*Input focus move up label*/\r\n.form__input:focus + .form__label {\r\n  top: -0.4rem;\r\n  left: 0.8rem;\r\n  color: $first-color;\r\n  font-size: $small-font-size;\r\n  font-weight: 500;\r\n  z-index: 10;\r\n}\r\n\r\n/*Input focus sticky top label*/\r\n.form__input:not(:placeholder-shown).form__input:not(:focus)\r\n+ .form__label {\r\n  top: -0.4rem;\r\n  left: 0.8rem;\r\n  font-size: $small-font-size;\r\n  font-weight: 500;\r\n  z-index: 10;\r\n}\r\n\r\n/*Input focus*/\r\n.form__input:focus {\r\n  border: 2px solid $first-color;\r\n}\r\n","@import \"../../common/components/input\";\r\n\r\n.login-page {\r\n  height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n  .form-container {\r\n    width: 100%;\r\n    max-width: 450px;\r\n    padding: 40px 20px;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n\r\n    @media (min-width: 576px) {\r\n      border: 1px solid #dadce0;\r\n      box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,\r\n        rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;\r\n      padding: 48px 38px;\r\n    }\r\n\r\n    .signIn-txt {\r\n      color: #212121;\r\n      font-size: 24px;\r\n      font-weight: 500;\r\n      line-height: 1.3333;\r\n      margin: 0.5rem 0 1rem;\r\n    }\r\n\r\n    .subtext {\r\n      color: gray;\r\n    }\r\n\r\n    .login-form {\r\n      margin-top: 2rem;\r\n\r\n      .login-btn.blue-btn {\r\n        background: #1a73e8;\r\n        color: #fff;\r\n        border: none;\r\n        vertical-align: middle;\r\n        font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n        font-weight: 500;\r\n        font-size: 0.9rem;\r\n        line-height: 1.75;\r\n        letter-spacing: 0.02857em;\r\n        text-transform: uppercase;\r\n        min-width: 64px;\r\n        padding: 9px 20px;\r\n        border-radius: 4px;\r\n        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),\r\n          0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);\r\n        transition: 0.4s;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          outline: none;\r\n          background: #0b5bc0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
